import EmbeddedFormPage from './EmbeddedFormPage';

const InsurancePage = () => (
  <EmbeddedFormPage
    titleKey="Insurance"
    description="Fill out this form to get started with Wonderschool Insurance. Insurance gives your program affordable liability and business coverage built specifically for childcare providers, so you can run your school with peace of mind."
    formUrl="https://wonderschool.fillout.com/t/5Z7nffahDCus"
  />
);

export default InsurancePage;
